import Layer from 'services/models/Layer';
import geoAlert from 'services/utils/alert';

import layerStyles from 'views/MapView/services/symbologiesStyles.json';

import SimpleModal from '@map/components/SimpleModal';
import Button from '@material-ui/core/Button';
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
import axios from 'axios';
/**
 * Importação do componente GeoBahiaLoader, responsavel
 * por carregar um gif enquanto o sistema esta processando.
 */
import GeoBahiaLoader from 'components/GeoBahiaLoader';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';
/**
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 * 
 * useMemo é um hook que retorna um valor memorizado.
 */
import { useEffect, useState, useCallback, useMemo } from 'react';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 * 
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 */
import { useMap, useModule } from 'views/MapView/hooks';

const PRA = ({ ...props }) => {
  const [action, setAction] = useState(null);
  const [type, setType] = useState(null);
  const [idImovel, setIdImovel] = useState(null);
  const [cod, setCod] = useState(null);
  const [idApp, setIdApp] = useState(null);
  const [idLoc, setIdLoc] = useState(null);
  const [token, setToken] = useState(null);
  const [nomeImovel, setNomeImovel] = useState('');
  const [degradedArea, setDegradedArea] = useState(0);
  const [loading, setLoading] = useState(true);

  const position = useMemo(
    () => ({
      x: window.innerWidth - 400 - window.innerWidth / 2,
      y: 100 - window.innerHeight / 2,
    }),
    []
  );

  const { addLayer, map, layers } = useMap();
  const { setElement } = useModule();

  // Add geometries as Layers to map
  /**
   * useCallback
   * 
   * @param {*} geojson
   * @param {string} style
   * @param {string} name
   * @param {*} type
   */
  const addGeoJSONLayer = useCallback(
    (geojson, style, name, paramType) => {
      const customRender = L.canvas({ pane: 'mixedPane' });

      let options = {
        pane: 'mixedPane',
        renderer: customRender,
        style: style,
      };

      const geoJsonLayer = L.geoJSON(geojson, options);
      
      let layerToAdd = new Layer(null, paramType, null, name, null, null, null, null, null);
      layerToAdd.setLeafletLayer(geoJsonLayer);
      layerToAdd.setLayerStyle(style);
      addLayer(layerToAdd, null, false);
      
      return layerToAdd;
    },
    [addLayer]
  );

  const loadTemas = useCallback(() => {
    if (type === 'rl' || type === 'app') {
      let params = {};

      if (type === 'app') {
        params.cod = cod;
        params.id_app = idApp;
      }

      setLoading(true);

      axios(`${process.env.REACT_APP_API_PRA_HOST}/temas-${type}/${idImovel}`, {
        params,
        headers: {
          Authorization: token,
        },
      })
      .then((response) => {
        if (!response.data.nome) {
          geoAlert({
            message: 'Não foi possível localizar o cadastro de Imóvel Rural informado!',
            callback: () => {
              window.close();
            },
          });
          return;
        }

        if (!response.data.limite) {
          geoAlert({
            message: 'Limite de Propriedade do Imóvel Rural não encontrado. Favor verificar e carregar a Localização Geográfica específica no SEIA!',
            callback: () => {
              window.close();
            },
          });
          return;
        }

        if (!response.data.rl && type === 'rl') {
          geoAlert({
            message: 'Poligonal da Reserva Legal não encontrada. Favor verificar e carregar a Localização Geográfica específica no SEIA!',
            callback: () => {
              window.close();
            },
          });
          return;
        }

        if (!response.data.app && type === 'app') {
          geoAlert({
            message: 'Poligonal da APP não encontrada. Favor verificar e carregar a Localização Geográfica específica no SEIA!',
            callback: () => {
              window.close();
            },
          });
          return;
        }
        
        setNomeImovel(response.data.nome);
        
        // Add Layers
        let imovelData = response.data.limite;
        addGeoJSONLayer(imovelData, layerStyles[0], 'Limite de Propriedade', 'importada');
        
        if (type === 'rl') {
          let rlData = response.data.rl;
          let rl = addGeoJSONLayer(rlData, layerStyles[1], 'Reserva Legal', 'importada');

          if (action === 'draw') {
            setElement('CPN-TB-D-DRAW', 'geometryLimit', rlData);
            setElement('CPN-TB-D-DRAW', 'geometryLimitMessage', 'Ao menos 90% da geometria deve estar contida dentro da Reserva Legal!');
          }

          map.flyToBounds(rl.leafletLayer.getBounds());
        } else if (type === 'app') {
          let appData = response.data.app;
          let app = addGeoJSONLayer(appData, layerStyles[1], 'Área de Preservação Permanente', 'importada');
          
          if (action === 'draw') {
            setElement('CPN-TB-D-DRAW', 'geometryLimit', appData);
            setElement('CPN-TB-D-DRAW', 'geometryLimitMessage', 'Pelo menos 90% da geometria deve estar contida dentro da APP!');
          }

          map.flyToBounds(app.leafletLayer.getBounds());
        }
      })
      .catch((err) => {
        // err.response.status === '404'
        geoAlert({
          message: 'Erro ao carregar camadas para visualização. Favor contatar o suporte do sistema!',
          callback: () => {
            window.close();
          },
        });
      })
      .finally(() => setLoading(false));
    }
  }, [action, addGeoJSONLayer, idImovel, map, setElement, type, cod, idApp, token]);

  const loadPrad = useCallback(() => {
    if (type === 'rl' || type === 'app') {
      let params = {};
      
      params.id_loc = idLoc;

      if (type === 'app') {
        params.cod = cod;
        params.id_app = idApp;
      }

      setLoading(true);
      
      axios(`${process.env.REACT_APP_API_PRA_HOST}/prad-${type}/${idImovel}`, {
        params,
        headers: {
          Authorization: token,
        },
      })
      .then((response) => {
        if (!response.data.rl && type === 'rl') {
          geoAlert({
            message: 'Poligonal da Reserva Legal não encontrada. Favor verificar e carregar a Localização Geográfica específica no SEIA!',
            callback: () => {
              window.close();
            },
          });
          return;
        }

        if (!response.data.pradRL && type === 'rl') {
          geoAlert({
            message: 'Poligonal da Área Degradada de Reserva Legal não encontrada. Favor verificar e carregar a Localização Geográfica específica no SEIA!',
            callback: () => {
              window.close();
            },
          });
          return;
        }

        if (!response.data.app && type === 'app') {
          geoAlert({
            message: 'Poligonal da APP não encontrada. Favor verificar e carregar a Localização Geográfica específica no SEIA!',
            callback: () => {
              window.close();
            },
          });
          return;
        }

        if (!response.data.pradApp && type === 'app') {
          geoAlert({
            message: 'Poligonal da Área Degradada de APP não encontrada. Favor verificar e carregar a Localização Geográfica específica no SEIA!',
            callback: () => {
              window.close();
            },
          });
          return;
        }

        // Add Layers
        if (type === 'rl') {
          let rlData = response.data.rl;
          let pradRlData = response.data.pradRL;
          let rl = addGeoJSONLayer(rlData, layerStyles[1], 'Reserva Legal', 'importada');
          
          pradRlData && addGeoJSONLayer(pradRlData, layerStyles[2], 'Área Degradada (Reserva Legal)', 'importada');

          map.flyToBounds(rl.leafletLayer.getBounds());
        } else if (type === 'app') {
          let appData = response.data.app;
          let pradAppData = response.data.pradApp;
          let app = addGeoJSONLayer(appData, layerStyles[1], 'Área de Preservação Permanente', 'importada');
          
          pradAppData && addGeoJSONLayer(pradAppData, layerStyles[2], 'Área Degradada (APP)', 'importada');

          map.flyToBounds(app.leafletLayer.getBounds());
        }
      })
      .catch((err) => {
        // err.response.status === '404'
        geoAlert({
          message: 'Erro ao carregar camadas para visualização. Favor contatar o suporte do sistema!',
          callback: () => {
            window.close();
          },
        });
      })
      .finally(() => setLoading(false));
    }
  }, [addGeoJSONLayer, idImovel, map, type, cod, idApp, idLoc, token]);

  // Get params from URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.get('id_imovel')) {
      window.location.href = '/feedback/pra';
    }
    setAction(urlParams.get('action') || 'view');
    setType(urlParams.get('type'));
    setIdImovel(urlParams.get('id_imovel'));
    setCod(urlParams.get('cod'));
    setIdApp(urlParams.get('id_app'));
    setIdLoc(urlParams.get('id_loc'));
    setToken(urlParams.get('token'));
  }, []);

  // Load Geometries from Backend
  useEffect(() => {
    if (map) {
      // Carrega as geometrias da API
      if (action === 'draw') {
        loadTemas();
      } else if (action === 'view') {
        loadPrad();
      }
    }
  }, [map, action, loadTemas, loadPrad, token]);

  // Update degraded area
  useEffect(() => {
    let totalArea = 0;
    
    if (action === 'draw') {
      let drawedPolygons = layers.filter((l) => l.type === 'criada');

      drawedPolygons.forEach((l) => {
        let polygonGeoJson = l.leafletLayer.toGeoJSON();
        let areaPolygon = (turf.area(polygonGeoJson) / 10000).toFixed(4); //hectares (ha)
        totalArea += parseFloat(areaPolygon);
      });
    }

    setDegradedArea(totalArea);
  }, [layers, action]);

  // Save geometries to Backend
  const savePolygons = () => {
    let drawedLayers = layers.filter((l) => l.type === 'criada');
    let drawedPolygons = [];

    drawedLayers.forEach((l) => {
      l.leafletLayer.eachLayer((el) => {
        let elGeoJson = el.toGeoJSON();
        elGeoJson.geometry && drawedPolygons.push(...elGeoJson.geometry.coordinates);
      });
    });

    if (drawedPolygons.length === 0) {
      geoAlert({
        message: 'É necessário desenhar pelo menos uma poligonal!',
      });
      return;
    }

    setLoading(true);
    
    let features = (drawedPolygons.length > 1) ? turf.multiPolygon([drawedPolygons]) : turf.polygon(drawedPolygons);
    features.properties.id = 1;
    features.properties.area_ha = degradedArea;

    if (type === 'rl' || type === 'app') {
      let bodyData = {
        id: idImovel,
        [type]: features,
      };

      if (type === 'app') {
        bodyData.cod = cod;
        bodyData.id_app = idApp;
      }

      axios
        .post(`${process.env.REACT_APP_API_PRA_HOST}/prad-${type}`, bodyData, {
          headers: {
            Authorization: token,
          },
        })
        .then((response) => {
          geoAlert({
            message: 'Delimitação da Área Degradada salva com sucesso!',
            callback: () => {
              window.close();
            },
          });
        })
        .catch((err) => {
          // err.response.status === '404'
          let errMsg =
            typeof err.response.data.detail === 'string'
              ? err.response.data.detail
              : err.response.data.detail.mensagem || 'Falha ao salvar!';
          geoAlert({
            message: errMsg,
          });
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <div id="pra">
      {action === 'draw' && (
        <SimpleModal
          title={nomeImovel || 'Carregando...'}
          open={true}
          onClose={() => null}
          relativePosition={position}
          zIndex={1200}
          closeButton={false}
        >
          <div>
            <b>Área degradada:</b> {degradedArea} ha
          </div>
          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <Button variant="contained" color="primary" onClick={savePolygons}>
              Salvar
            </Button>
          </div>
        </SimpleModal>
      )}
      <GeoBahiaLoader open={loading} />
    </div>
  );
};

PRA.properties = {
  id: 'CPN-MA-PRA',
  alias: 'Plano de Recuperação Ambiental - PRA',
  description: '...',
};

export default PRA;
